import React, { Fragment } from 'react';
import { Modal, Card } from 'antd';
import { formatTimestamp, formatPrice } from 'utils/utils.js';
import styles from './Index.less';

export default class IncomeDetailModal extends React.Component {
  constructor(props) {
    super(props);

    this.renderContent = this.renderContent.bind(this);
  }

  renderContent() {
    const { detail, loading, showStudentInfo } = this.props;

    if (loading !== false) {
      return null;
    }

    const commodityNames = [];
    const commodityProperties = [];
    const commodityPrices = [];
    detail.commodities.forEach(commodity => {
      commodityNames.push(`【${commodity.commodityName}】`);
      const propertiesName = commodity.propertiesName.replace(/;/g, ',') || '无';
      commodityProperties.push(`【${propertiesName}】`);
      commodityPrices.push(`【${formatPrice(commodity.price)}】`);
    });

    return (
      <Fragment>
        <p>
          <span className="label">订单号</span>
          {detail.id}
        </p>

        <p>
          <span className="label">收款商户</span>
          {detail.merchants.map(q => q.merchantName).join('、')}
        </p>

        <p>
          <span className="label">商户号</span>
          {detail.merchants.map(q => q.merchantId).join('、')}
        </p>

        <p>
          <span className="label">学校</span>
          {detail.orgName}
        </p>

        {showStudentInfo && (
          <Fragment>
            <p>
              <span className="label">年级</span>
              {detail.parentStructName}
            </p>
            <p>
              <span className="label">班级</span>
              {detail.structName}
            </p>
            <p>
              <span className="label">姓名</span>
              {detail.userName}
            </p>
          </Fragment>
        )}

        <p>
          <span className="label">操作用户id</span>
          {detail.userId}
        </p>

        <p>
          <span className="label">已购商品名</span>
          {commodityNames.join('')}
        </p>

        <p>
          <span className="label">规格</span>
          {commodityProperties.join('')}
        </p>

        <p>
          <span className="label">商品价格</span>
          {commodityPrices.join('')}
        </p>

        <p>
          <span className="label">订单金额</span>
          {formatPrice(detail.actualPrice)}
        </p>

        <p>
          <span className="label">服务费</span>
          {formatPrice(detail.fee)}
        </p>

        <p>
          <span className="label">实际到账金额</span>
          {formatPrice(detail.afterFeePrice)}
        </p>

        <p>
          <span className="label">支付方式</span>
          {detail.payMethodStr}
        </p>

        <p>
          <span className="label">支付时间</span>
          {formatTimestamp(detail.gmtPaid)}
        </p>
      </Fragment>
    );
  }

  render() {
    const { visible, loading, onCancel } = this.props;
    if (visible === false) {
      return null;
    }

    return (
      <Modal
        title="详情"
        className={styles.root}
        footer={null}
        visible
        onCancel={() => {
          if (onCancel) {
            onCancel();
          }
        }}
      >
        <Card bordered={false} loading={loading}>
          {this.renderContent()}
        </Card>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IncomeDetailModal/Index.js